import {
  ROBOT_PART_REPLACE_SUCCESS,
} from './replaceRobotPartRequest';

export const replaceRobotPartSuccess = () => ({
  type: ROBOT_PART_REPLACE_SUCCESS,
  payload: {
  },
});
